import * as React from 'react';

import { inject, observer } from 'mobx-react';

import { EStore } from '@enums';

import { getContainerHOC, getUserName, renderChildren } from '@utils';

import { fetchData } from '@decorators';

import { IAppState } from '@mobx';

import { AppStat } from '@common/utils/AppStat';

import {
	ISharePlaylistProps,
	ISharePlaylistChildrenProps,
	ISharePlaylistOwnProps,
	IRouteParams,
	IQueryParams,
} from './types';

@inject(EStore.PLAYLISTS)
@observer
@fetchData([
	async ({ playlistsStore }: IAppState, params: IRouteParams, query: IQueryParams) => {
		if (!playlistsStore.itemShareNetworkStatus.isFetched ||
			playlistsStore.itemShare.apiId !== params.id
		) {
			return playlistsStore.fetchItemShare(params.id, { shareAuth: query.share_auth });
		}
	},
])
class SharePlaylistContainer extends React.Component<ISharePlaylistProps> {

	componentDidMount() {
		AppStat.log.share.playlistOpen();
	}

	getDescription() {
		const { playlistsStore: { itemShare: playlist } } = this.props;

		return getUserName(playlist?.owner);
	}

	render() {
		const {
			children,
			playlistsStore: { itemShare: playlist },
		} = this.props;

		return renderChildren<ISharePlaylistChildrenProps>(children, {
			playlist,
			description: this.getDescription(),
		});
	}

}

export const withSharePlaylistContainer = getContainerHOC<ISharePlaylistOwnProps, ISharePlaylistChildrenProps>(SharePlaylistContainer);
